import React, {Component} from 'react';
import {Typography, Icon} from 'material-ui';
import {withStyles} from 'material-ui/styles';



const style = {
    root: {
        
    },
    icon_empty :{
        'font-size': '20vw',
        'color': 'transparent',
        'text-shadow': '0px 0px 2px hsl(199, 2%, 91%), 0 0 0 #666'
    }
}


class NoQuoteCard extends Component{
    render(){
        return(
            <section className="flex flex-auto layout-column">
                        <div className="flex flex-auto layout-column flex-end">
                                <div className="flex layout-row justify-center">
                                    <Icon color="primary" classes={{root:this.props.classes.icon_empty}}>new_releases</Icon>
                                </div>
                        </div>
                        <div className="flex flex-auto layout-column justify-center">
                            <div>
                                <div className="flex layout-row justify-center">
                                    <Typography paragraph={true} variant="subheading" style={{fontFamily: "Lobster", color:"rgb(48,48,48)"}}>No quotes, yet!</Typography>
                                </div>
                                <div className="flex layout-row justify-center text-center">
                                    <Typography style={{color: '#777'}} variant="body2">No worries! You will receive your first quote tomorrow.</Typography>
                                </div>
                            </div>
                        </div>
                    </section>
        )
    }
}


export default withStyles(style)(NoQuoteCard);


// WEBPACK FOOTER //
// ./src/Components/NoQuoteCard.js